import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, FormGroup, Div, Forms, H3, LabelField } from './Severance.styles';
import apis from '../../api';
import { saveAs } from 'file-saver';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import useParamsSeverance from '../../helpers/useParamsSeverance'
import dateFormat from '../../services/DateFormat.service';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { addLocale } from 'primereact/api'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { ProgressBar } from 'primereact/progressbar';
import Video from '../Video/Video';
import useParamsSeverancePlain from '../../helpers/useParamsSeverancePlain';
import { excelReport } from '../../services/excelReport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Severance
Description : Configuración de la nómina de una empresa.
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el forumlario desde cero.
03/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo en cuenta los cambios realizados con PrimeReact
================================================================================ */

export default function Severance(props) {

    /*Propiedades y listas de valores del componente*/
    const toast = useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const [calendar, setCalendar] = useState("");
    const [listaOptionsCalendar, setOptionsCalendar] = useState([{ "value": "", "label": "" }]);
    const elementWidth = { width: "20rem", justifySelf: "center" }
    const headers = { authorization: localStorage.getItem('token') }
    const client = localStorage.getItem('client');
    const [isOpenRS, setIsOpenRS] = React.useState(false);
    const [isOpenPlain, setIsOpenPlain] = React.useState(false);
    const [isOpenAcum, setIsOpenAcum] = React.useState(false);
    const [params] = useParamsSeverance();
    const [paramsPlain] = useParamsSeverancePlain();
    const [severance, setSeverance] = useState([]);
    const [plain, setPlain] = useState([]);

    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [consultado, setConsultado] = useState(false)
    const [loadingProcesar, setLoadingProcesar] = useState(false);
    const [loadingAcomular, setLoadingAcomular] = useState(false);
    const [loadingDeshacer, setLoadingDeshacer] = useState(false);
    const [loadingGenerar, setLoadingGenerar] = useState(false);
    const [loadingConsultar, setLoadingConsultar] = useState(false);
    const [loadingFlat, setLoadingFlat] = useState(false);

    const [errorRows, setErrorRows] = useState([])
    const [isOpenErrors, setIsOpenErrors] = useState(false)

    useEffect(() => {
        /*Se cargan los datos de la lista de valores de calendario*/
        listCalendar();
    }, []);

    useEffect(() => {
        const severanceTemplate = async () => {
            /*Se inicializan las propiedades del reporte detallado de cesantías*/
            let plantilla = []
            params.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setSeverance(plantilla)
        }
        severanceTemplate()
    }, [params]);

    useEffect(() => {
        const plainTemplate = () => {
            /*Se inicializan las propiedades del reporte detallado de cesantías*/
            let plantilla = []
            paramsPlain.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            setPlain(plantilla)
        }
        plainTemplate()
    }, [paramsPlain]);

    /*Formato del calendario del componente*/
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    function handleSubmit(event) {
        event.preventDefault();
    }
    /*Funciones que manejan el comportamiento de los modales del componente*/
    const showModalRS = () => {
        setIsOpenRS(true);
    };


    const showModal = () => {
        setIsOpen(true);
        setCalendar("")
    }

    const hideModal = () => {
        setIsOpen(false);
        setConsultado(false)
    }

    const hideModalRS = () => {
        setIsOpenRS(false);
    };

    const showModalAcum = () => {
        setIsOpenAcum(true);
    };

    const hideModalAcum = () => {
        setIsOpenAcum(false);
    };

    const hideModalPlain = () => {
        setIsOpenPlain(false);
    };

    const showModalPlain = () => {
        setIsOpenPlain(true);
    };

    async function listCalendar() {
        /*Función encargada de de cargar los datos e la lista de valores del calendario*/
        await apis.getValueListCalendar('CES', headers).then(res => {
            let data = res.data.CALENDAR
            let tipoCalendar = data;
            let contenidoTipoCalendar = [];
            tipoCalendar.forEach(res =>
                contenidoTipoCalendar.push({ "value": '' + res.ID_CALENDAR + '', "label": '' + res.DETAIL + '' })
            )
            setOptionsCalendar(contenidoTipoCalendar)
        }).catch(err => {
            setOptionsCalendar([])
        })
    }

    async function process(action) {
        /*Función encargada de validar que proceso se realizará*/

        if (action == "PRO") {
            setLoadingProcesar(true)
        } if (action == "CLO") {
            setLoadingAcomular(true)
        } if (action == "REV") {
            setLoadingDeshacer(true)
        }

        const p = {
            ID_CALENDAR: calendar.value,
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            ACTION: action
        }
        await apis.executeProcess(p, headers).then(res => {
            switch (action) {
                case "PRO":
                    setLoadingProcesar(false)
                    setTabla()
                    return toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'PROCESADO CON EXITO', life: 4000 });
                case "CLO":
                    setLoadingAcomular(false)
                    hideModalAcum()
                    setTabla()
                    return toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'ACUMULADO CON EXITO', life: 4000 });
                case "REV":
                    setLoadingDeshacer(false)
                    setTabla()
                    return toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'REVERSADO CON EXITO', life: 4000 });
            }
        }).catch(err => {
            setLoadingDeshacer(false)
            setLoadingAcomular(false)
            setLoadingProcesar(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
        })
    }

    async function postSeveranceReport() {
        /*Función encargada de de cargar los datos del reporte detallado de cesantías*/
        setLoadingGenerar(true)
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        severance.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        severance.forEach(n => {
            n.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
            })
        })
        try {
            await apis.postReportSeverance(report, headers).then(res => {
                setLoadingGenerar(false)
                finalReport = res.data
                excelReport(finalReport, 'reporte_cesantias')
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de cesantías generado existosamente" });
            })
        }
        catch (err) {
            setLoadingGenerar(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function plainSeveranceReport() {
        setLoadingFlat(true)
        let type = "text/csv;charset=utf-8"
        let extension = ".csv"
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        plain.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        plain.forEach(n => {
            n.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
            })
        })

        try {
            await apis.postReportFlatSeverance(report, headers).then(res => {
                let resp = res.data.SHEETS[0]
                let fileName = resp.NAME
                let data = resp.DETAIL
                let _data = flatToCsv(data)
                setLoadingFlat(false)
                saveAsFile(_data, fileName, type, extension)
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Plano de cesantías generado existosamente" });
            })
        }
        catch (err) {
            setLoadingFlat(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    function flatToCsv(data) {
        let csvStr = ""
        data.forEach(n => {
            csvStr += n.LINE + '\r\n'
        })
        return csvStr
    }

    const saveAsFile = (buffer, fileName, type, extension) => {
        /*Función encargada de guardar y descargar el archivo Excel del reporte detallado de cesantías*/
        import('file-saver').then(FileSaver => {
            const data = new Blob([buffer], {
                type: type
            });
            FileSaver.default.saveAs(data, fileName + '_' + dateFormat(new Date()) + extension);
        });
    }

    async function setTabla() {
        setLoadingConsultar(true)
        const _calendario = calendar.value
        try {
            await apis.getExecutedProcess(localStorage.getItem('entity'), _calendario, localStorage.getItem('client'), "NULL", headers).then(res => {
                setLoadingConsultar(false)
                if (res.data["PROCESS"].length > 0) {
                    let data = res.data["PROCESS"]
                    setRows(data)
                    setConsultado(true)
                }
                else {
                    setRows([])
                }
            })
        }
        catch (err) {
            setLoadingConsultar(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const tableHeader = (
        <div className="table-header">
            <Button icon="pi pi-refresh" tooltip="Refrescar tabla" tooltipOptions={{ position: 'top' }} className="p-button-succcess mr-2 p-button-sm" onClick={() => setTabla()} />
        </div>
    );

    const rowClassName = (rowData) => {
        return { 'error-row': (rowData["STATUS"] === "ERROR") };
    }

    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const percentageBodyTemplate = (rowData) => {
        return <ProgressBar value={rowData.PERCENTAGE}></ProgressBar>;
    }

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];


    /*Headers y footers de los modales del componente*/
    const headerS = (
        <div>
            <h3>Seleccionar calendario para liquidar Cesantias</h3>
        </div>
    )

    const actionBodyTemplateErrors = (rowData) => {
        console.log(rowData.ERRORS)
        return (
            <div>
                {rowData.ERRORS && <Button icon="pi pi-search" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Visualizar errores" tooltipOptions={{ position: 'top' }} onClick={() => { setErrorRows(rowData.ERRORS); setIsOpenErrors(true) }} />}
            </div>
        )
    }

    const footerS = (
        <>
            <div>
                <Button onClick={() => process("PRO")} disabled={calendar.value == undefined} loading={loadingProcesar} label='Procesar'></Button>
                <Button onClick={() => process("REV")} disabled={calendar.value == undefined} loading={loadingDeshacer} label='Deshacer'></Button>
                <Button onClick={showModalAcum} disabled={calendar.value == undefined} label='Acumular'></Button>
            </div>
            {consultado === true && calendar.value != undefined ?
                <div className="datatable-style-demo">
                    <DataTable className="text-xs" header={tableHeader} value={rows} first={first2} rows={rows2} onPage={onCustomPage2}
                        responsiveLayout="scroll" selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
                        size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['ID', 'TRHEAD', 'JOB', 'RECORD', 'START', 'END', 'PROCESSED', 'ERROR', 'PERCENTAGE', 'ACTION', 'STATUS']}
                        rowClassName={rowClassName}
                    >
                        <Column showFilterOperator={false} filterMatchModeOptions={matchModes} body={actionBodyTemplateErrors}></Column>
                        <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID" sortable></Column>
                        <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                        <Column field="PERCENTAGE" header="Porcentaje" body={percentageBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Porcentaje" sortable></Column>
                        <Column field="ACTION" header="Proceso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Proceso" sortable></Column>
                        <Column field="TRHEAD" header="Hilo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hilo" sortable></Column>
                        <Column field="RECORD" header="Registro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Registro" sortable></Column>
                        <Column field="START" header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
                        <Column field="END" header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
                        <Column field="PROCESSED" header="Procesados" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Procesados" sortable></Column>
                        <Column field="ERROR" header="Error" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Error" sortable></Column>
                    </DataTable>
                </div>
                : null}
        </>
    );

    /*Funciones que manejan el cambio en los campos de entrada dl componente*/
    function handleChange(e, d, index) {
        //console.log(e.value)
        setSeverance(n => {
            let newNomina = [...n]
            newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    async function handleChangeDate(e, d, index) {
        let date = dateFormat(e.value)
        setSeverance(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    async function handleChangeText(e, d, index) {
        setSeverance(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    /*Funciones que manejan el cambio en los campos de entrada dl componente*/
    function handleChangePlain(e, d, index) {
        //console.log(e.value)
        setPlain(n => {
            let newNomina = [...n]
            newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    async function handleChangeDatePlain(e, d, index) {
        let date = dateFormat(e.value)
        setPlain(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    async function handleChangeTextPlain(e, d, index) {
        setPlain(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
    }

    /*Headers y footers de los modales del componente*/
    const headerRS = (
        <div>
            <h3>Parámetros reporte de Cesantias</h3>
        </div>
    )

    const footerRS = (
        <div>
            <Button loading={loadingGenerar} onClick={() => postSeveranceReport()} label='Generar' />
        </div>
    );

    const headerPlain = (
        <div>
            <h3>Parámetros reporte plano de Cesantias</h3>
        </div>
    )

    const footerPlain = (
        <div>
            <Button loading={loadingFlat} onClick={() => plainSeveranceReport()} label='Generar' />
        </div>
    );

    const headerAcum = (
        <div>
            <h3>¿Desea realizar la acumulación del proceso?</h3>
        </div>
    )

    const footerAcum = (
        <div>
            <Button label="Si" loading={loadingAcomular} onClick={() => { setLoadingAcomular(true); process("CLO") }} />
            <Button label="No" onClick={hideModalAcum} />
        </div>
    );

    /*Renderizado del componente*/
    return (
        <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
            <Toast ref={toast} style={{ backgroundColor: 'white' }} />


            <Dialog header={headerS} footer={footerS} visible={isOpen} maximizable
                position="top" style={{ width: "40rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <div className='block'>
                    <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                </div>

                <LabelField htmlFor="label">Calendario liquidación de Cesantías *</LabelField>
                <div className="p-inputgroup">
                    <Dropdown style={elementWidth} value={calendar.value}
                        filter showClear filterBy="label" emptyMessage={"No hay calendarios disponibles"}
                        options={listaOptionsCalendar} placeholder={"Seleccione calendario"}
                        onChange={(e) => {
                            let label = e.originalEvent.nativeEvent.target.textContent;
                            setCalendar({ "value": e.value, "label": label })
                        }}
                    />
                    <Button icon="pi pi-search" loading={loadingConsultar} disabled={calendar.value == undefined} className="mr-2 p-button-sm text-xs" tooltip="Consultar procesos anteriores" tooltipOptions={{ position: 'top' }} onClick={() => setTabla()} />
                </div>
            </Dialog>
            <Dialog header={headerAcum} footer={footerAcum} visible={isOpenAcum} position="top"
                style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalAcum} />
            <Dialog header={headerRS} footer={footerRS} visible={isOpenRS} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalRS}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                {params.map((d, index) => {
                    /*Genera dinámica de los campos de entrada para el reporte*/
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && severance.length > 0 && typeof severance[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={severance[index]["NAME"]}
                                        options={options}
                                        filter filterBy="NAME"
                                        optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={severance[index]["NAME"] ? severance[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChange(e, d, index)}
                                    />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Calendar key={d} style={elementWidth} id="navigators" value={severance[index].CODE}
                                        onChange={(e) => handleChangeDate(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={severance[index].CODE}
                                        yearRange="2010:2030" /></>
                                );
                            default:
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    {/* {console.log(severance[index])} */}
                                    <InputText

                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"

                                        value={severance[index].NAME}
                                        onChange={(e) => handleChangeText(e, d, index)}
                                    /></>
                                )
                        }
                    }
                })}
            </Dialog>

            <Dialog header={headerPlain} footer={footerPlain} visible={isOpenPlain} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalPlain}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                {paramsPlain.map((d, index) => {
                    /*Genera dinámica de los campos de entrada para el reporte*/
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && plain.length > 0 && typeof plain[index] !== "undefined") {
                        let label = d.LABEL;
                        if (d.REQUIRED === "1") {
                            label = label + "*"
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = []
                                if (d.REQUIRED === "1") {
                                    options = [...d.OPTIONS]
                                }
                                else {
                                    options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                }
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={plain[index]["NAME"]}
                                        options={options}
                                        filter filterBy="NAME"
                                        optionLabel="NAME" emptyMessage={"No hay " + label + "s disponibles"}
                                        //optionTemplate={optionTemplate}
                                        placeholder={plain[index]["NAME"] ? plain[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChangePlain(e, d, index)}
                                    />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Calendar key={d} style={elementWidth} id="navigators" value={plain[index].CODE}
                                        onChange={(e) => handleChangeDatePlain(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={plain[index].CODE}
                                        yearRange="2010:2030" /></>
                                );
                            default:
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    {/* {console.log(severance[index])} */}
                                    <InputText

                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"

                                        value={plain[index].NAME}
                                        onChange={(e) => handleChangeTextPlain(e, d, index)}
                                    /></>
                                )
                        }
                    }
                })}
            </Dialog>

            <Dialog header={"Errores"} visible={isOpenErrors}
                position="top" style={{ width: "70vw" }} draggable={false} resizable={false} modal onHide={() => setIsOpenErrors(false)}>
                <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">

                    <DataTable className="text-xs" value={errorRows} dataKey="CONTRACT_ID">
                        <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false}></Column>
                        <Column field="MESSAGE" header="Mensaje" showFilterOperator={false}></Column>
                    </DataTable>
                </div>
            </Dialog>

            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
                <span className="text-900">Liquidación</span>
                <Video header="Instructivo proceso cesantías" url={localStorage.getItem('SEVERANCE_VIDEO')} />
            </div>
            <Form onSubmit={handleSubmit}>
                <Card className='shadow-5'>
                    <H3>Consignación de Cesantias</H3>
                    <Div>
                        <FormGroup>
                            <Button block type="submit" label="Liquidar consignación" onClick={showModal} />
                        </FormGroup>
                    </Div>

                    <H3>Consulta</H3>
                    <Div>
                        <FormGroup>
                            <Button block type="submit" label="Reporte detallado cesantías" onClick={showModalRS} />
                        </FormGroup>
                    </Div>
                    <Div>
                        <FormGroup>
                            <Button block type="submit" label="Reporte plano cesantías"
                                // loading={loadingFlat}
                                onClick={showModalPlain}
                            />
                        </FormGroup>
                    </Div>
                </Card>
            </Form>
        </div>
    );
}